import React from "react";

interface BookIconProps {
  className?: string;
  width?: string;
  height?: string;
}

export const BookIcon = ({ className, width, height }: BookIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 13"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.34375 4.25H4.40625C4.21875 4.25 4.125 4.15625 4.125 3.96875V3.78125C4.125 3.59375 4.21875 3.5 4.40625 3.5H8.34375C8.53125 3.5 8.625 3.59375 8.625 3.78125V3.96875C8.625 4.15625 8.53125 4.25 8.34375 4.25ZM8.625 5.46875C8.625 5.65625 8.53125 5.75 8.34375 5.75H4.40625C4.21875 5.75 4.125 5.65625 4.125 5.46875V5.28125C4.125 5.09375 4.21875 5 4.40625 5H8.34375C8.53125 5 8.625 5.09375 8.625 5.28125V5.46875ZM10.1484 11.75H10.2188C10.4062 11.75 10.5 11.8438 10.5 12.0312V12.2188C10.5 12.4062 10.4062 12.5 10.2188 12.5H1.875C1.35938 12.5 0.914062 12.3125 0.539062 11.9375C0.179688 11.5781 0 11.1406 0 10.625V2.375C0 1.85938 0.179688 1.42187 0.539062 1.0625C0.914062 0.6875 1.35938 0.5 1.875 0.5H9.9375C10.0938 0.5 10.2266 0.554687 10.3359 0.664062C10.4453 0.773438 10.5 0.90625 10.5 1.0625V9.6875C10.5 9.9375 10.3828 10.1094 10.1484 10.2031C10.0391 10.7031 10.0391 11.2188 10.1484 11.75ZM3 9.5H9.75V1.25H3V9.5ZM0.75 9.875C1.07812 9.625 1.45312 9.5 1.875 9.5H2.25V1.25H1.875C1.5625 1.25 1.29688 1.35938 1.07812 1.57812C0.859375 1.79687 0.75 2.0625 0.75 2.375V9.875ZM9.46875 11.75C9.39062 11.25 9.39062 10.75 9.46875 10.25H1.875C1.40625 10.25 1.07031 10.375 0.867188 10.625C0.679688 10.875 0.679688 11.125 0.867188 11.375C1.07031 11.625 1.40625 11.75 1.875 11.75H9.46875Z" />
  </svg>
);

BookIcon.defaultProps = {
  className: "",
  width: "16",
  height: "16",
};
